import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar-cajas-x-linea',
  templateUrl: './progress-bar-cajas-x-linea.component.html',
  styleUrls: ['./progress-bar-cajas-x-linea.component.scss']
})
export class ProgressBarCajasXLineaComponent {
    @Input() progress: number = 0;
    @Input() cajas_x_linea: number = 0;
    @Input() cajas_encintadas: number = 0;
    @Input() promedio: string = '';
    @Input() color1: string = '';
    @Input() color2: string = '';
    @Input() linea: number = 0;

}
